import React from 'react';
import { Monitor } from '../config/monitor';

/**
 * SILENT MONITOR ERROR BOUNDARY
 * ----------------------------
 * Captures errors for Sentry/Observability but does not show an intrusive UI.
 * This prevents the "White Screen of Death" by rendering nothing (null)
 * for the crashed component while keeping the rest of the app potentially alive.
 */
const MonitorErrorBoundary = ({ children }) => {
  return (
    <Monitor.ErrorBoundary
      fallback={({ error }) => {
        // In development, we still want to see the error in the console
        if (process.env.NODE_ENV === 'development') {
          console.error('Caught by MonitorErrorBoundary:', error);
        }

        // Return null so the UI just stays silent instead of showing a big modal
        return null;
      }}
    >
      {children}
    </Monitor.ErrorBoundary>
  );
};

export default MonitorErrorBoundary;
